
import { Component, Mixins, Prop, Vue } from "vue-property-decorator";
import Chart from "chart.js";
import VueChart from "vue-chartjs";
import "chartjs-plugin-zoom";

/**
 * Time series chart
 */
@Component
export default class TimeSeriesChart extends Mixins(
  VueChart.Line,
  VueChart.mixins.reactiveProp
) {
  /**
   * Time series chart data
   */
  @Prop({ required: true, default: {} })
  public chartData!: Chart.ChartData;

  /**
   * Time series time unit
   */
  @Prop()
  public timeUnit?: Chart.TimeUnit;

  /**
   * y axes customizations
   */
  @Prop()
  public yAxesConf?: Chart.ChartYAxe[];

  private internalTimeUnit!: Chart.TimeUnit;

  // time series chart options
  private options: Chart.ChartOptions = {};

//   // chart instance
//   private chart!: Chart;

  // chart instance to handle zoom actions
  private zoomChartInstance!: Chart;

  mounted() {
      this.applyOptions();
      // draw time series chart
      this.renderChart(this.chartData, this.options);
    //   this.chart = this.$data._chart;
  }

  private applyOptions() {
    if (!this.timeUnit) {
      this.internalTimeUnit = "hour";
    } else {
      this.internalTimeUnit = this.timeUnit;
    }
    this.options.scales = {
      xAxes: [
        {
          type: "time",
          time: {
            unit: this.internalTimeUnit,
          },
          gridLines: {
            display: false,
          },
        },
      ],
      yAxes: [
        {
          gridLines: {
            display: true,
          },
        },
      ],
    };
    if (this.yAxesConf) {
      this.options.scales.yAxes = this.yAxesConf
    }
    this.options.legend = {
      display: true,
    };
    this.options.tooltips = {
      enabled: true,
    };
    this.options.responsive = true;
    this.options.maintainAspectRatio = false;
    this.options.plugins = {
      zoom: {
        pan: {
          enabled: true,
          mode: "xy",
          speed: 20,
          threshold: 10,
          onPan: (event: any) => {
            this.zoomChartInstance = event.chart;
          },
          onPanComplete: (event: any) => {
            this.zoomChartInstance = event.chart;
          },
        },
        zoom: {
          enabled: true,
          drag: false,
          mode: (event: any) => {
            return "xy";
          },
          speed: 0.1,
          sensitivity: 3,
          onZoom: (event: any) => {
            console.log(event);
            this.zoomChartInstance = event.chart;
          },
          onZoomComplete: (event: any) => {
            this.zoomChartInstance = event.chart;
          },
        },
      },
    };
  }
}
